/**
 * Method to check if locale is sent and extract country
 *
 * @param {string} data
 *
 * @return {string|null}
 */
export const getCountryFromLocale = (data) => {
  if (typeof data !== "string") return null

  if (data.length === 2) return data.toUpperCase()

  const parts = data.split("-")
  if (parts.length === 2 && parts[1].length === 2) return parts[1].toUpperCase()

  return null
}
